const incrementCount = (map, key) => {
  if (!key) return;
  map[key] = (map[key] || 0) + 1;
};

const findTopKey = (map) => {
  let topKey = null;
  let topCount = 0;
  Object.entries(map).forEach(([key, count]) => {
    if (count > topCount) {
      topCount = count;
      topKey = key;
    }
  });
  return topKey;
};

export const buildWellnessSummary = (wellnessRecords = [], { role } = {}) => {
  if (!Array.isArray(wellnessRecords) || wellnessRecords.length === 0) {
    return null;
  }

  const emotionCounts = {};
  const actionCounts = {};
  const helpfulCounts = { true: 0, false: 0 };

  wellnessRecords.forEach((record) => {
    incrementCount(emotionCounts, record?.emotion);
    incrementCount(actionCounts, record?.action);
    if (typeof record?.helpful === "boolean") {
      helpfulCounts[record.helpful ? "true" : "false"] += 1;
    }
  });

  const total = wellnessRecords.length;
  const helpfulRate =
    total > 0 ? Number((helpfulCounts.true / total).toFixed(4)) : 0;

  return {
    type: "wellness_summary",
    period: "all_loaded",
    scopeType: "role",
    scopeId: role || "unknown",
    metrics: {
      total,
      emotionCounts,
      actionCounts,
      helpfulCounts,
      helpfulRate,
    },
    createdAt: new Date().toISOString(),
  };
};

export const toMixpanelSummaryProps = (summary, { role } = {}) => {
  if (!summary?.metrics) return null;
  const { metrics, period } = summary;
  return {
    period,
    total: metrics.total,
    top_emotion: findTopKey(metrics.emotionCounts || {}),
    top_action: findTopKey(metrics.actionCounts || {}),
    helpful_rate: metrics.helpfulRate,
    role: role || summary.scopeId,
  };
};
